;(function ($) {

    $.fn.archiveSearchForm = function (options) {

        var $searchform = this,
            $keyword = this.find('.search'),
            $searchoptions = this.find(".search-options");

        $searchoptions.on('change', 'input', function(event) {

            var inputval = $keyword.val().replace(/"/g, '');

            if (!$('#search-method-all').is(':checked')) {
                inputval = '"' + inputval + '"';
            }

            $keyword.val(inputval);

        });

        $searchform.on('change', '#y-select', function () {
            $searchform.submit();
        });

        $searchform.on('change', '#subcat-select', function () {
            if ($(this).val() !== '') {
                window.location = $(this).val();
            }
        });

        return this;

    };


})(jQuery);